import { render, staticRenderFns } from "./robotDrawer.vue?vue&type=template&id=3107dd0c"
import script from "./robotDrawer.vue?vue&type=script&lang=js"
export * from "./robotDrawer.vue?vue&type=script&lang=js"
import style0 from "./robotDrawer.vue?vue&type=style&index=0&id=3107dd0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports